import { useParams } from 'react-router-dom';
import { usePublicOrganization } from './usePublicOrganization.ts';

/**
 * The practice of the current practice-scoped patient route (/praktijk/:orgSlug/…).
 * `practice` is undefined while loading and null when the slug doesn't exist.
 */
export function usePractice() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  const { data: practice } = usePublicOrganization(orgSlug);
  return { slug: orgSlug!, practice };
}
